import { Button, Grid, List, ListItem, ListItemText, Stack, Typography } from "@mui/material";
import Modal from "../../../App/Components/Modal/Modal";
import {
  ICandidate,
  ICandidateEmailAddress,
  ICandidateLocation,
  ICandidatePhoneNumber,
} from "../../../App/Typings/Candidate";
import { ICandidateHistory, ICandidateProfile } from "../../../App/Typings/CandidateProfile";
import { ArrowForward } from "@mui/icons-material";

export default function CandidateDiffModal({
  isOpen,
  candidate,
  onClose,
  selectedCandidate,
  onRollbackClick,
}: {
  isOpen: boolean;
  candidate: ICandidateProfile;
  onClose: () => void;
  selectedCandidate: ICandidateHistory;
  onRollbackClick: (history: ICandidateHistory) => void;
}) {
  const compareFields = ["firstName", "lastName", "emailAddresses", "phoneNumbers", "locations"];

  return (
    <>
      <Modal
        size="lg"
        handleCloseModal={onClose}
        isOpen={isOpen}
        title="Candidate History Comparison"
        dataTestId="candidate-diff"
        content={
          <Grid container>
            <Grid item xs={5}>
              <Typography variant="h6">Current Candidate</Typography>
              <List dense>
                {compareFields
                  .filter((field) => field in candidate)
                  .map((field) => {
                    return (
                      <ListItem key={`current-candidate-${field}`}>
                        <ListItemText
                          primary={printField(field, candidate[field as keyof ICandidateProfile])}
                        />
                      </ListItem>
                    );
                  })}
              </List>
            </Grid>
            <Grid item xs={2}>
              <Stack direction="column" justifyContent="center" sx={{ height: "100%" }}>
                <ArrowForward />
              </Stack>
            </Grid>
            <Grid item xs={5}>
              <Typography variant="h6">New Candidate</Typography>
              <List dense>
                {compareFields
                  .filter((field) => field in selectedCandidate.changedCandidate)
                  .map((field) => {
                    const fieldValue = printField(
                      field,
                      selectedCandidate.changedCandidate[field as keyof ICandidate],
                    );
                    const compareValue = printField(field, candidate[field as keyof ICandidateProfile]);

                    return (
                      <ListItem key={`change-candidate-${field}`}>
                        <ListItemText
                          sx={{ color: fieldMatch(fieldValue, compareValue) ? "initial" : "green" }}
                          primary={fieldValue}
                        />
                      </ListItem>
                    );
                  })}
              </List>
            </Grid>
          </Grid>
        }
        footerContent={
          <>
            <Stack direction="row" spacing={2} justifyContent="flex-end">
              <Button
                variant="contained"
                data-test="candidate-diff-rollback-btn"
                color="primary"
                onClick={() => onRollbackClick(selectedCandidate)}
              >
                Rollback
              </Button>
            </Stack>
          </>
        }
      />
    </>
  );
}

const fieldMatch = (field: string, field2: string) => {
  return field.toLowerCase() === field2.toLowerCase();
};

const printField = (field: string, value: any) => {
  if (field === "locations") {
    return value.map((location: ICandidateLocation) => location.name).join(", ");
  }
  if (field === "emailAddresses") {
    return value.map((email: ICandidateEmailAddress) => email.emailAddress).join(", ");
  }
  if (field === "phoneNumbers") {
    return value.map((phone: ICandidatePhoneNumber) => phone.phoneNumber).join(", ");
  }
  return value;
};
